module.exports = __webpack_public_path__ + "static/media/whistle-dog-2024-mb-en.b36904d3.jpg";